/** Швидкий фільтр списку (UIUX patterns/filtering: «Усі · Призначені мені · Відкрито · Прострочено» з лічильниками). */
import type { IListViewState, IRecordTypeDefinition } from '@platform/core/types';

/** Значення швидкого фільтра в порядку списку «Фільтр». */
export const quickFilters: readonly IListViewState['quickFilter'][] = ['all', 'mine', 'open', 'overdue'];

/** Умови, яким не відповідає жоден запис (тип без поля, від якого залежить варіант: «Призначені мені» без виконавця, «Прострочено» без терміну). */
export const NO_RECORDS = 'isClosed:eq:false;isClosed:eq:true';

/** Запис не завершено: статус поза глобальним переліком DONE прототипу (псевдополе фільтр-DSL `isDone`, а не прапорець closed модуля). */
const NOT_DONE = 'isDone:eq:false';

/**
 * Умови фільтр-DSL варіанта швидкого фільтра за правилом прототипу v4 (QF): «Призначені мені» — виконавець я, зокрема в закритих записах;
 * «Відкрито» — статус поза DONE; «Прострочено» — термін раніше за сьогодні й статус поза DONE. Варіант завжди йде умовами фільтра, а не
 * пресетом (пресети меню рахують «відкрите» за closed модуля й сортують по-своєму). Тип без поля виконавця чи терміну — порожній результат,
 * як у прототипі (`r.v.assignee`/`r.v.due` порожні). «Усі» — без умов. Чиста функція.
 */
export function quickFilterDsl(quick: IListViewState['quickFilter'], rt: IRecordTypeDefinition): string | undefined {
  const has = (key: string) => rt.fields.some((f) => f.key === key);
  switch (quick) {
    case 'mine': return has('assignee') ? 'assignee:eq:me' : NO_RECORDS;
    case 'open': return NOT_DONE;
    case 'overdue': return has('due') ? `${NOT_DONE};due:lt:today` : NO_RECORDS;
    default: return undefined;
  }
}
